module.exports = __webpack_public_path__ + "img/pieGraphImgLogin.f63e51e1.svg";